export interface NS3451Element {
  code: number;
  name_no: string;
  name_en?: string;
  collection_id: string;
  item_id?: string;
  description_no?: string;
  description_en?: string;
}

export const ns3451_elements: NS3451Element[] = [
  {
    code: 11,
    name_no: "Dokumenter for Forvaltning",
    name_en: "Documents for Management",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
  },
  {
    code: 111,
    name_no: "Kjøpskontrakter",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "purchaseContracts",
  },
  {
    code: 112,
    name_no: "Leiekontrakter",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "rentalContracts",
  },
  {
    code: 113,
    name_no: "Drifts- og vedlikeholds- og serviceavtaler",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "serviceAgreements",
  },
  {
    code: 114,
    name_no: "Vedtekter for boligselskap",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "housingAssociation",
  },
  {
    code: 115,
    name_no: "Garantidokument (lovpålågt eller avtalt)",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "guarantees",
  },
  {
    code: 116,
    name_no: "Protokoller (overtagelse, ettårsbefaring og garantitidens utløp)",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "protocols",
  },
  {
    code: 117,
    name_no: "Adresselister (leverandører)",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "addressLists",
  },
  {
    code: 118,
    name_no: "Forsikringer",
    collection_id: "kh8tGxU2hrRWgvavpKtV",
    item_id: "insurances",
  },
  {
    code: 12,
    name_no: "Juridiske og offentlige dokumenter",
    name_en: "Legal and public documents",
    collection_id: "Cj5HezlL1blfybCdoBtW",
  },
  {
    code: 121,
    name_no: "Matrikkelinformasjon",
    collection_id: "Cj5HezlL1blfybCdoBtW",
    item_id: "cadastre",
    description_no:
      "Matrikkelinformasjon foreligger blant annet i matrikkelbrev, som er et attestert dokument fra kommunen som blant annet inneholder kommune, gårdsnummer, bruksnummer, bolignummer, tomteareal og bygningsnummer.",
  },
  {
    code: 122,
    name_no: "Seksjoneringsplan",
    collection_id: "Cj5HezlL1blfybCdoBtW",
    item_id: "sectioningPlan",
  },
  {
    code: 123,
    name_no: "Offentligrettslige betingelser for drift av eiendommen",
    collection_id: "Cj5HezlL1blfybCdoBtW",
    item_id: "lawConditions",
  },
  {
    code: 124,
    name_no: "Ferdigattest og midlertidig brukstillatelse",
    collection_id: "Cj5HezlL1blfybCdoBtW",
    item_id: "certificatesPermits",
  },
  {
    code: 13,
    name_no: "Tomt",
    name_en: "Plot",
    collection_id: "hKBIdxZql9pMK9tfSYFI",
  },
  {
    code: 131,
    name_no: "Tomtebefaring",
    collection_id: "hKBIdxZql9pMK9tfSYFI",
    item_id: "inspection",
  },
  {
    code: 132,
    name_no: "Beskyttelse av vegetasjon og vekstjord",
    collection_id: "hKBIdxZql9pMK9tfSYFI",
    item_id: "vegetationSoil",
  },
  {
    code: 133,
    name_no: "Målinger og rapporter",
    collection_id: "hKBIdxZql9pMK9tfSYFI",
    item_id: "measurements",
  },
  {
    code: 14,
    name_no: "Dimensjonering",
    name_en: "Dimensioning",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
  },
  {
    code: 141,
    name_no: "Energiberegninger",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
    item_id: "8LRpSxzLHO2AWDPPOHYX",
    description_no: "Beregninger av energibehov, energiforsyning mm.",
  },
  {
    code: 142,
    name_no: "Bærekraftsberegninger",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
    item_id: "uzWw24fll3MmPh3xbv3M",
  },
  {
    code: 143,
    name_no: "Statiske beregninger",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
    item_id: "Qckt0Qrnu5M7XMT0RGYF",
  },
  {
    code: 144,
    name_no: "Inneklima",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
    item_id: "cXRY7MdioQCZtHK4sohB",
  },
  {
    code: 145,
    name_no: "Målinger",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
    item_id: "vqK2irLlHlQCcx4EkVh2",
  },
  {
    code: 146,
    name_no: "Tilpasningsdyktighet",
    collection_id: "wgJVAycmaZVBUG4c5EFD",
    item_id: "adaptability",
  },
  {
    code: 15,
    name_no: "Miljødokumentasjon",
    name_en: "Environmental documentation",
    collection_id: "364xAf4hIYvPYVG5qCEl",
  },
  {
    code: 151,
    name_no: "Miljøkonsept",
    collection_id: "364xAf4hIYvPYVG5qCEl",
    item_id: "GNzwKYbXWrh5UC0uHOCS",
  },
  {
    code: 152,
    name_no: "Miljøsertifisering",
    collection_id: "364xAf4hIYvPYVG5qCEl",
    item_id: "w4ux5KkNVVUbx92dembt",
  },
  {
    code: 153,
    name_no: "Klimaregnskap",
    collection_id: "364xAf4hIYvPYVG5qCEl",
    item_id: "climateAccounting",
  },
  {
    code: 154,
    name_no: "Energiattest",
    collection_id: "364xAf4hIYvPYVG5qCEl",
    item_id: "DP7ExKR61PFaxx36rQfh",
  },
  {
    code: 155,
    name_no: "Miljøkartlegging og sanering",
    collection_id: "364xAf4hIYvPYVG5qCEl",
    item_id: "mappingRemediation",
  },
  {
    code: 156,
    name_no: "Skadedyr",
    collection_id: "364xAf4hIYvPYVG5qCEl",
    item_id: "pests",
  },
  {
    code: 16,
    name_no: "Tegninger, planer og kart",
    name_en: "Drawings, plans and maps",
    collection_id: "5SFgyG48yvUPqeK46mfm",
  },
  {
    code: 161,
    name_no: "Offentlige plan- og reguleringsdokumenter",
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "NrIdVuKaMzynROE0GZgg",
    description_no: "Reguleringsplan, reguleringsbestemmelser, rekkefølgebetingelser mm.",
  },
  {
    code: 162,
    name_no: "Situasjonsplan for byggesaken",
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "95JEB86ThPkHj3r8ksz1",
    description_no: "Grov skisse av eiendommen sett ovenfra, inkludert bygningene på tomten. Baseres på situasjonskart fra kommunen.",
  },
  {
    code: 163,
    name_no: 'Arbeidstegninger / "som bygget"-tegninger',
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "3zKHumIvWK2EmHFBiLTw",
    description_no: "Originalfiler og pdf av tegninger.",
  },
  {
    code: 164,
    name_no: "Plantegninger",
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "OsUsxVmHhQ2Fye9NIbRn",
    description_no:
      "Tekniske tegninger som viser bygget sett ovenfra med detaljert informasjon om innholdet, slik som byningens rominndeling, bærende vegger og skillevegger.",
  },
  {
    code: 164,
    name_no: "Fasadetegninger",
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "8YuTz6mH0znb4l1tOK2N",
    description_no: "Tekniske tegninger som viser byggets fasader. Inkluderer også terrenglinjer rundt bygningen.",
  },
  {
    code: 164,
    name_no: "Representative snitt",
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "qPe2pSzkf04JIORiQKXy",
    description_no:
      'Tekniske tegninger som viser bygget sett fra siden. " + "Inkluderer innvendige og utvendige høyder, byggets høydeplassering over havet, terrenglinjer, yttervegger og tak med riktig tykkelse samt takvinkel med angitt grad.',
  },
  {
    code: 165,
    name_no: "Modeller",
    collection_id: "5SFgyG48yvUPqeK46mfm",
    item_id: "models",
  },
  {
    code: 17,
    name_no: "Brannvern",
    name_en: "Fire protection",
    collection_id: "48XpfDXBTssPhNOUb0Vv",
  },
  {
    code: 171,
    name_no: "Brannkonsept",
    collection_id: "48XpfDXBTssPhNOUb0Vv",
    item_id: "8YuTz6mH0znb4l1tOK2N",
    description_no:
      "Et brannkonsept skal på en systematisk og oversiktlig måte vurdere alle relevante branntekniske forhold ved bygningen. Brannkonseptet bør bestå av en egen rapport vedlagt branntekniske tegninger.",
  },
  {
    code: 172,
    name_no: "Rømningsplan",
    collection_id: "48XpfDXBTssPhNOUb0Vv",
    item_id: "OsUsxVmHhQ2Fye9NIbRn",
    description_no:
      "Rømningsplaner er dokumenter som viser hvor nærmeste nødutgang er, hvor man skal gå om det oppstår brann, samt vise hvor nærmeste slokkeutstyr er plassert.",
  },
  {
    code: 173,
    name_no: "Orienteringsplan",
    collection_id: "48XpfDXBTssPhNOUb0Vv",
    item_id: "qPe2pSzkf04JIORiQKXy",
    description_no:
      "Orienteringsplan (ofte kalt O-plan) for brannalarm viser omfang av område sikret med brannalarmanlegg og anleggsoppdeling. Orienteringsplanen skal i kombinasjon med informasjon fra brannsentralen gi brann- og redningspersonell informasjon om hvor alarmen er utløst og en oversikt om hvordan man kommer dit (orientere seg).",
  },
  {
    code: 174,
    name_no: "Branntekniske tegninger/planer",
    collection_id: "48XpfDXBTssPhNOUb0Vv",
    item_id: "BNKjfqsd1pSGrbwucBdA",
    description_no:
      "For å få god oversikt over de branntekniske hovedprinsippene må prosjekterende utarbeide egne branntekniske tegninger. Brannteknisk informasjon kan gjerne tegnes på arkitektens planskisser.",
  },
  {
    code: 18,
    name_no: "Sikkerhet",
    name_en: "Security",
    collection_id: "4aSwCuU9yzbHg7uEzus2",
  },
  {
    code: 181,
    name_no: "Sikkerhet mot naturpåkjenning",
    collection_id: "4aSwCuU9yzbHg7uEzus2",
    item_id: "YoJwlMjXCIJaUX9Tptu5",
  },
  {
    code: 182,
    name_no: "Graderingsspesifikasjon",
    collection_id: "4aSwCuU9yzbHg7uEzus2",
    item_id: "MlGI3yXGcmfbNP4bWyF3",
    description_no: "Brukes i forbindelse med sikkerhetsgraderinger",
  },
  {
    code: 183,
    name_no: "Andre sikkerhetsvurderinger",
    collection_id: "4aSwCuU9yzbHg7uEzus2",
    item_id: "igddd6D054hAOZ3KYeg0",
  },
  {
    code: 19,
    name_no: "Drift og vedlikehold",
    name_en: "Operation and maintenance",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
  },
  {
    code: 191,
    name_no: "Drifts- og vedlikeholdsplan for bygning",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "maintenance",
  },
  {
    code: 192,
    name_no: "Opplæringsplaner (kvittert gjennomført)",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "training",
  },
  {
    code: 193,
    name_no: "Renholdsplan",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "cleaning",
  },
  {
    code: 194,
    name_no: "Renovasjonsplan",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "renovation",
  },
  {
    code: 195,
    name_no: "Prøvedrift",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "trial",
  },
  {
    code: 196,
    name_no: "Brøyteplan",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "plowing",
  },
  {
    code: 197,
    name_no: "Drifts- og vedlikeholdsplan utomhus",
    collection_id: "py3pGJAQmvWz1Qf8k6TZ",
    item_id: "outdoor",
  },
];

